import { createContext, FC, PropsWithChildren, useContext } from 'react';

import { MockDbtCloudProject } from '@/MockDbtCloudProject';

type DevelopmentContextDataProps = PropsWithChildren<{}> & {
  accountId: number | undefined;
  projectId: number | undefined;
  environmentId: number | undefined;
  projectName: string | undefined;
  mockProjects: MockDbtCloudProject[];
};

type DevelopmentContextData = DevelopmentContextDataProps & {
  isDev: boolean;
  disableAdminApi: boolean;
  shouldMockProjects: boolean;
};

const DevelopmentContext = createContext<DevelopmentContextData>({
  accountId: undefined,
  projectId: undefined,
  environmentId: undefined,
  projectName: undefined,
  isDev: false,
  disableAdminApi: false,
  shouldMockProjects: false,
  mockProjects: [],
});

export const useDevelopmentContext = () => {
  return useContext(DevelopmentContext);
};

/**
 * Does nothing if not in development mode.
 */
export const DevelopmentContextProvider: FC<DevelopmentContextDataProps> = (props) => {
  const disableAdminApi = !!(props.accountId && props.projectId && props.environmentId);

  const shouldMockProjects = import.meta.env.VITE_SHOULD_MOCK_PROJECTS === 'true';
  return (
    <DevelopmentContext.Provider
      value={{
        ...props,
        isDev: true,
        disableAdminApi,
        shouldMockProjects,
      }}
    >
      {props.children}
    </DevelopmentContext.Provider>
  );
};
